import parternParaEmprendedores from '../Componentes/Logos/logo-paraemprendedores.svg'
const cardsData = [
    {
      imgSrc: parternParaEmprendedores,
      companyName: "Para Emprendedores",
      companyCountry: "Perú",
      companyAbout: "Somos una agencia especializada en el desarrollo de software y la automatización de WhatsApp utilizando inteligencia artificial. Ofrecemos soluciones innovadoras y personalizadas que optimizan la comunicación y la eficiencia operativa de nuestros clientes. Nuestro equipo de expertos combina tecnología de vanguardia con un profundo conocimiento del mercado para crear herramientas que transforman la interacción digital. Nos dedicamos a impulsar el crecimiento y la competitividad de las empresas mediante la implementación de sistemas inteligentes y automatizados",
      classification: "Silver Partner",
      Url:"www.paraemprendedores.pe",
      email:'hola@paraemprendedores.pe'
    },
    
  ];
  
  export default cardsData;